<div class="error-body">
    <div class="transaction-error-container">
      <i class="fa fa-times-circle icon-error"></i>
      <h1 class="trx-rechazado">Error al pagar</h1>
    </div>
    <div class="card-container">
      <div class="body-text">
        <p>{{ errorMessage }}</p>
        <p>Puede intentar nuevamente ingresando a <a [href]="linkRetry">este enlace</a>.</p>
      </div>
    </div>
  </div>